export const formContentStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	item: {
		display: 'flex',
		gap: '24px',
	},

	itemField: {
		width: '100%',
	},

	buttons: {
		display: 'flex',
		gap: '24px',
		alignItems: 'center',
		marginTop: '58px',
	},

	button: {
		height: '44px',
	},
};
